import {departmentVI} from "./department/vi";
import {UserAccountVI} from "./user-account/vi";
import {NotificationVI} from "./notification/vi";

export const AdminVI = {
    ...departmentVI,
    ...UserAccountVI,
    ...NotificationVI
}